<script setup lang="ts">
    import { __ } from '../stores/expressions';
    import ChangeLanguage from '../components/settings/ChangeLanguage.vue';
    import SettingsPageLayout from '../components/settings/SettingsPageLayout.vue';
    import UserAvatar from '../components/UserAvatar.vue';
    import FormGroup from '../components/FormGroup.vue';
</script>
<template>
    <SettingsPageLayout>
        <template #header>
            <h1 class="heading-lg-light">{{ __('settings-general') }}</h1>
        </template>
        <template #content>
            <div class="w-full flex items-center gap-4 pb-12 mb-12 border-b border-gray-lightest">
                <UserAvatar :label="$userInfo?.name" size="xl" color="avocado" />
                <div class="flex flex-col gap-1">
                    <h3 class="heading-lg">
                        {{ $userInfo?.name }}
                    </h3>
                    <p class="text-body text-gray-dark">
                        {{ $userInfo?.email }}
                    </p>
                </div>
            </div>

            <FormGroup>
                <div>
                    <ChangeLanguage />
                </div>
            </FormGroup>
        </template>
    </SettingsPageLayout>
</template>
